import styled, { css } from "styled-components";
import { colors } from './../../variables';


export const Catchline = styled.h1`
  position: relative;
  font-size: 24px;
  line-height: 24px;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 20px;
  text-transform: uppercase;
  @media (max-width: 991px){
    position: relative;
    text-align: center;
    left: inherit;
    font-size: 26px;
    line-height: 28px;
    color: #4a4a4a;
    position: relative;
    display: block;
  }
`;

export const ConfirmWrapper = styled.div`
  width: 400px;
  background-color: transparent;
  border-radius: 0px;
  position: relative;
  margin-top: 0px;
  z-index: 30;
  left: 50%;
  margin-left: -200px;
  @media (max-width: 991px){
    position: relative;
    background-color: transparent;
    border: 0px;
    margin: 0 auto;
    left: inherit;
    width: 100%;
    margin-top: 90px;
  }
`;

export const Sep = styled.div`
  height: 1px;
  width: 20%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #4a4a4a;
  @media (max-width: 991px){
    background-color: #4a4a4a;
  }
`;

export const ConfirmContent = styled.div`
  padding: 20px 40px;
  color: #4a4a4a;
  text-align: center;
  button{
    display: inline-block;
    @media (max-width: 991px){
      padding: 0px 50px;
    }
  }
`;

export const ConfirmTitle = styled.div`

  margin-top: 20px;
  font-size: 32px;
  line-height: 32px;
  color: #4a4a4a;
  text-align: center;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
`;

export const ConfirmMessage = styled.div`
  margin-top: 5px;
  font-size: 14px;
  text-transform: normal;
  color: #4a4a4a;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
`;

export const ResumeVideo = styled.div`
  background-color: #000;
  width: 100%;
  border-radius: 0px;
  overflow: hidden;
  position: relative;
  height: auto!important;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #aaa;
  @media (max-width: 767px){
    width: 100%;
    height: 200px;
  }
`;

export const ShareTitle = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  color: #4a4a4a;
  font-weight: bold;
`;

export const ShareList = styled.ul`
  margin: 0px;
  padding: 0px;
  margin-top: 15px;
`;

export const ShareListItem = styled.li<{color: string}>`
  list-style: none;
  display: inline-block;
  margin: 5px 5px;
  color: #4a4a4a;
  
  a{
    background-color: ${props => props.color};
    color: #4a4a4a;
    display: flex;
    font-size: 11px;
    padding: 5px 2px;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    border-radius: 5px;
  }
  img{
    height: 25px;
    width: auto;
    margin-right: 5px;
    filter: invert(1);
  }
`;